module.exports = __webpack_public_path__ + "res/ic_poll_result_h.c89bc24f73c53c35b39fb149645dcd88.png";